export default {
    name: 'CustomerIndex'
}